import React, { Suspense } from 'react';
import './Main.css';
import ThemeProvider from '@ascension/web/components/common/ThemeProvider';
import configureStore from './store';
import { Provider } from 'react-redux';
import { Routes } from './Routes';
import { MuiThemeProvider } from '@material-ui/core';
import theme from './theme/theme';
import '@ascension/ui-library/dist/fonts/WhitneySSm.css';
import '@ascension/ui-library/dist/fonts/ChronicleSSm.css';
import { LaunchDarklyAppWrapper } from '@components/LaunchDarklyAppWrapper/LaunchDarklyAppWrapper';

const App: React.FC = () => {
	return (
		<Provider store={configureStore()}>
			<LaunchDarklyAppWrapper>
				<MuiThemeProvider theme={theme}>
					<ThemeProvider>
						<Suspense fallback={<p>Loading...</p>}>
							<Routes />
						</Suspense>
					</ThemeProvider>
				</MuiThemeProvider>
			</LaunchDarklyAppWrapper>
		</Provider>
	);
};

export default App;
